<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>课程管理</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <div class="search-line clearfix">
          <select
            class="s-select separate"
            v-model="queryInfo.province"
            @change="getSchool(queryInfo.province,1)"
            v-if="[0].indexOf(localUser.role) >= 0"
          >
            <option value="">
              请选择省份
            </option>
            <option
              :value="index"
              v-for="(item,index) in dict_province"
              :key="index"
            >
              {{item}}
            </option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.school_id"
            @change="getAcademy(queryInfo.school_id,1)"
            v-if="[0,2].indexOf(localUser.role) >= 0"
          >
            <option value=''>请选择学校</option>
            <option
              v-for="(item, index) in searceSchoolData"
              :key="index"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.academy_id"
            v-if="[0,2,3].indexOf(localUser.role) >= 0"
          >
            <option value="">请选择院系</option>
            <option
              v-for="item in searchAcademyData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <select
            class="s-select separate"
            @change="getSubject(queryInfo.subjectCategory_id,1)"
            v-model="queryInfo.subjectCategory_id"
          >
            <option value="">对应专业大类</option>
            <option
              :value="item.id"
              v-for="item in categoryData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.subject_id"
          >
            <option value="">对应专业</option>
            <option
              :value="item.id"
              v-for="item in subjectData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.time_status"
          >
            <option value="">课程时间状态</option>
            <option value="1">未开始</option>
            <option value="2">进行中</option>
            <option value="3">已结束</option>
          </select>
          <input
            type="text"
            v-model="queryInfo.title"
            placeholder="课程名称"
            class="s-input separate"
          >
          <input
            type="text"
            v-model="queryInfo.manager_name"
            placeholder="课程负责人"
            class="s-input separate"
          >
          <input
            type="button"
            value="搜索"
            class="s-btn"
            @click="queryInfo.page = 1; search()"
          >
        </div>
        <hr>
        <div class="search-line clearfix">
          <div class="state-btn">
            <div
              class="li"
              :class="{ 'liActive' : stateOnclik==='' }"
              @click="stateOnclik='',stateSearch()"
            >全部</div>
            <div
              class="li"
              :class="{ 'liActive' : stateOnclik===index }"
              v-for="(item, index) in stateDate"
              :key="item.code"
              @click="stateOnclik=index, stateSearch(item.code)"
            >
              {{item.title}}
            </div>
          </div>
          <div
            class="add-btn"
            @click="showAddWindow"
            v-if="localUser.role == 11"
          >新建课程</div>
        </div>
      </div>
      <div id="list">
        <table v-if="tableData.length">
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">课程名称</th>
              <th class="itemStatus">学期</th>
              <th class="itemStatus">专业大类</th>
              <th class="itemStatus">专业类</th>
              <th class="itemStatus">课程负责人</th>
              <th class="itemStatus">审核人</th>
              <th class="itemStatus">创建人</th>
              <th class="itemStatus">课程状态</th>
              <th class="itemStatus">课程时间状态</th>
              <th
                class="action"
                width="160"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in tableData"
              :key="item.id"
            >
              <td class="itemStatus">{{item.title}}</td>
              <td class="itemStatus">{{formatTerm(item.term)}}</td>
              <td class="itemStatus">{{item.subject_category_title?item.subject_category_title:'--'}}</td>
              <td class="itemStatus">{{item.subject_title?item.subject_title:'--'}}</td>
              <td class="itemStatus">{{item.manager_name?item.manager_name:'--'}}</td>
              <td class="itemStatus">{{item.auditor_name?item.auditor_name:'--'}}</td>
              <td class="itemStatus">{{item.creator_name?item.creator_name:'--'}}</td>
              <td
                class="itemStatus"
                :class="item.status==0?'itemStatus0':item.status==1?'itemStatus1':item.status==2?'itemStatus4':'itemStatus3'"
              >{{$store.state.dict_course_state[item.status]}}</td>
              <td class="itemStatus">
                {{ formatTimeStatus(item) == 1 ? '未开始' : '' }}
                {{ formatTimeStatus(item) == 2 ? '进行中' : '' }}
                {{ formatTimeStatus(item) == 3 ? '已结束' : '' }}
              </td>
              <td class="action">
                <router-link
                  class=""
                  :to="'/online/basic?id=' + item.id"
                >管理</router-link>
                <router-link
                  class="see"
                  tag="a"
                  :to="'/www/lesson_detail?id=' + item.id"
                >预览</router-link>
                <a
                  class="modify"
                  href="javascript:;"
                  v-if="(parseInt(localUser.role) <= 4 || localUser.role == '')"
                  @click="showPersonWindow(item)"
                >负责人</a>
                <a
                  class="edit"
                  href="javascript:;"
                  v-if="item.status != 0 && parseInt(localUser.role) <= 4"
                  @click="Editable(item)"
                >设为可编辑</a>
                <a
                  class="edit"
                  href="javascript:;"
                  v-if="formatTimeStatus(item) == 3 && item.status == 5 && (parseInt(localUser.role) <= 4 || parseInt(localUser.role) == 11 || localUser.role == '')"
                  @click="addTerm(item)"
                >添加学期</a>
                <a
                  class="edit"
                  href="javascript:;"
                  v-if="(item.status==2 || item.status==5) && (parseInt(localUser.role) <= 4 || localUser.role == '')"
                  @click="askRelease(item)"
                >{{item.status==2?'发布' : '取消发布'}}</a>
                <a
                  class="publish"
                  v-if="item.status == 1 && (parseInt(localUser.role) <= 4 || localUser.role == '')"
                  href="javascript:;"
                  @click="showExamineWindow(item.id)"
                >审核</a>
                <a
                  class="edit"
                  v-if="item.status != 5 && (parseInt(localUser.role) <= 4 || localUser.role == '')"
                  href="javascript:;"
                  @click="querySingle(item.id, 1)"
                >编辑</a>
                <a
                  class="edit"
                  href="javascript:;"
                  v-if="parseInt(localUser.role) <= 4 || localUser.role == ''"
                  @click="askDel(item)"
                >删除</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
      <!-- 课程添加/编辑弹窗 -->
      <div
        class="form_overlay"
        style="z-index: 2;"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">课程管理</div>
          <div class="form_content">
            <form>
              <div class="item">
                <span class="label"><i class="require">*</i>课程名称:</span>
                <input
                  type="text"
                  v-model="formInfo.title"
                  autocomplete="off"
                  maxlength="20"
                  :disabled="formInfo.id === 0 ? false : true"
                >
              </div>
              <div
                class="item"
                v-if="localUser.role==0"
              >
                <span class="label"><i class="require">*</i>省份:</span>
                <select
                  v-model="formInfo.province"
                  @change="getSchool(formInfo.province)"
                >
                  <option value="">
                    请选择省份
                  </option>
                  <option
                    :value="index"
                    v-for="(item,index) in dict_province"
                    :key="index"
                  >
                    {{item}}
                  </option>
                </select>
              </div>
              <div
                class="item"
                v-if="[0,2].indexOf(localUser.role) >= 0"
              >
                <span class="label"><i class="require">*</i>学校:</span>
                <select
                  v-model="formInfo.school_id"
                  @change="getAcademy(formInfo.school_id)"
                >
                  <option value=''>请选择学校</option>
                  <option
                    v-for="(item, index) in schoolData"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
              <div
                class="item"
                v-if="[0,2,3].indexOf(localUser.role) >= 0"
              >
                <span class="label"><i class="require">*</i>学院:</span>
                <select v-model="formInfo.academy_id">
                  <option value="">请选择院系</option>
                  <option
                    v-for="item in academyData"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>专业大类:</span>
                <select
                  class="s-select separate"
                  @change="getSubject(formInfo.subjectCategory_id)"
                  v-model="formInfo.subjectCategory_id"
                >
                  <option value="">对应专业大类</option>
                  <option
                    :value="item.id"
                    v-for="item in categoryData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>专业:</span>
                <select
                  class="s-select separate"
                  v-model="formInfo.subject_id"
                >
                  <option value="">对应专业</option>
                  <option
                    :value="item.id"
                    v-for="item in formSubjectData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              @click="saveInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 审核 -->
      <div
        class="form_overlay"
        :style="classShowExamineWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">审核课程</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>课程名称:</span>
                <input
                  type="text"
                  v-model="formInfo.title"
                  disabled
                  autocomplete="off"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>审核结果:</span>
                <form method="post">
                  <input
                    type="radio"
                    style="margin-right:5px"
                    v-model="formInfo.status"
                    value="2"
                  >通过
                  <input
                    type="radio"
                    style="margin-left:10px;margin-right:5px"
                    v-model="formInfo.status"
                    value="3"
                  >不通过
                </form>
              </div>
              <div class="item">
                <span class="label">审核意见:</span>
                <textarea
                  rows="5"
                  v-model="formInfo.audit_option"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideExamineWindow()"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="examineBtn"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 负责人弹窗 -->
      <div
        id="c-panel"
        :style="classShowPersonWindow"
      >
        <div id="c-panel-bg"></div>
        <div
          class="c-content"
          style="width:820px"
        >
          <form
            id="search"
            onsubmit="return false;"
            style="width:820px;position:relative"
          >
            <select
              class="s-text"
              v-model="userInfo.province"
              @change="getSchool(userInfo.province,2)"
              v-if="[0].indexOf(localUser.role) >= 0"
            >
              <option value="">
                请选择省份
              </option>
              <option
                :value="index"
                v-for="(item,index) in dict_province"
                :key="index"
              >
                {{item}}
              </option>
            </select>
            <select
              class="s-text"
              v-model="userInfo.school_id"
              @change="getAcademy(userInfo.school_id,2)"
              v-if="[0,2].indexOf(localUser.role) >= 0"
            >
              <option value=''>请选择学校</option>
              <option
                v-for="(item, index) in searceSchoolData"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </select>
            <select
              class="s-text"
              v-model="userInfo.academy_id"
              v-if="[0,2,3].indexOf(localUser.role) >= 0"
            >
              <option value="">请选择院系</option>
              <option
                v-for="item in searchAcademyData"
                :key="item.id"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </select>
            <input
              type="text"
              class="s-text"
              v-model="userInfo.username"
              placeholder="用户名"
              autocomplete="off"
              style="width:120px"
            >
            <input
              type="text"
              class="s-text"
              v-model="userInfo.name"
              placeholder="姓名"
              autocomplete="off"
              style="width:120px"
            >
            <input
              type="submit"
              class="s-btn1"
              @click="pageCalluser(1)"
              value="查询"
            >
            <span
              class="close-cpanel"
              @click="hidePersonWindow"
            ></span>
          </form>
          <div
            id="uList"
            style="padding-top: 0;"
          >
            <table>
              <tbody>
                <tr class="l_header">
                  <th>用户名</th>
                  <th>姓名</th>
                  <th>性别</th>
                  <th class="action">操作</th>
                </tr>
                <tr
                  class="item"
                  v-for="(item, index) in userData"
                  :key="index"
                >
                  <td>{{item.username}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.gender==1?'男': '女'}}</td>
                  <td class="action">
                    <a
                      class="a-button"
                      v-if="item.id != userForm.manager_id"
                      href="javascript:;"
                      @click="selectManager(item.id)"
                    >选择</a>
                    <span v-else>负责人</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 分页 -->
          <pagination
            :cur='useInfo.page'
            :all='useInfo.all'
            :totalData="useInfo.totalData"
            :callback="pageCalluser"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  components: {
    Pagination
  },
  // 数据对象
  data () {
    return {
      stateOnclik: '',
      queryInfo: {
        page: 1,
        size: 10,
        subjectCategory_id: '',
        subject_id: '',
        title: '',
        manager_name: '',
        status: '',
        province: '',
        school_id: '',
        academy_id: '',
        time_status: ''
      },
      categoryData: [],
      subjectData: [],
      formInfo: {
        id: 0,
        title: '',
        province: '',
        school_id: '',
        academy_id: '',
        subjectCategory_id: '',
        subject_id: '',
        status: 0,
        term: 1,
        audit_option: null,
        isPub: -1
      },
      userInfo: {
        page: 1,
        size: 8,
        role: 11,
        province: '',
        school_id: '',
        academy_id: '',
        username: '',
        name: ''
      },
      userForm: {
        title: '',
        experiment_id: '',
        manager_id: ''
      },
      userData: [],
      userDataCount: '',
      stateDate: [
        {
          code: '0',
          title: '建设中'
        },
        {
          code: '1',
          title: '待审核'
        },
        {
          code: '2',
          title: '审批通过'
        },
        {
          code: '3',
          title: '不通过'
        },
        {
          code: '5',
          title: '已发布'
        }
      ],
      tableData: [],
      tableDataCount: 0,
      classShowAddWindow: {},
      classShowExamineWindow: {},
      classShowPersonWindow: {
        display: 'none'
      },
      academyData: [],
      searchAcademyData: [],
      majorData: [],
      querymajorData: [],
      allMajorData: [],
      schoolData: [],
      searceSchoolData: [],
      formSubjectData: []
    }
  },
  // 事件处理器
  methods: {
    formatTerm(value) {
      var term = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      let text = ''
      if (value.toString().length === 1) {
        text = term[value]
      } else if (value.toString().length === 2) {
        text = term[value.toString()[0]] + '十' + term[value.toString()[1]]
      } else if (value.toString().length === 3) {
        text = term[value.toString()[0]] + '百' + term[value.toString()[1]] + '十' + term[value.toString()[2]]
      } else if (value.toString().length === 4) {
        text = term[value.toString()[0]] + '千' + term[value.toString()[1]] + '百' + term[value.toString()[2]] + '十' + term[value.toString()[2]]
      }
      return '第' + text + '学期'
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    getNowTime () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
      const time = '' + year + '-' + this.addZero(month) + '-' + this.addZero(day) + ' ' + this.addZero(hour) + ':' + this.addZero(minute) + ':' + this.addZero(second)
      return time
    },
    formatTimeStatus (item) {
      if (!item.startTime || !item.endTime) {
        return 0
      }
      const curTime = this.getNowTime()
      if (item.startTime.replace('T', ' ') > curTime) {
        return 1
      }
      if (curTime >= item.startTime.replace('T', ' ') && item.endTime.replace('T', ' ') >= curTime) {
        return 2
      }
      if (curTime > item.endTime.replace('T', ' ')) {
        return 3
      }
      return 0
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    pageCalluser(data) {
      this.userInfo.page = data
      this.getUser()
    },
    showAddWindow() {
      this.formInfo.id = 0
      this.formInfo.title = ''
      this.formInfo.province = ''
      this.formInfo.school_id = ''
      this.formInfo.academy_id = ''
      this.formInfo.subjectCategory_id = ''
      this.formInfo.subject_id = ''
      this.formInfo.status = 0
      this.formInfo.term = 1
      this.formInfo.audit_option = null
      this.formInfo.isPub = -1

      if ([2].indexOf(this.localUser.role) >= 0) {
        this.formInfo.province = this.localUser.province
        this.getSchool(this.localUser.province)
      }
      if ([3].indexOf(this.localUser.role) >= 0) {
        this.formInfo.province = this.localUser.province
        this.formInfo.school_id = this.localUser.school_id
        this.getAcademy(this.localUser.school_id)
      }
      if ([4, 11].indexOf(this.localUser.role) >= 0) {
        this.formInfo.province = this.localUser.province
        this.formInfo.school_id = this.localUser.school_id
        this.formInfo.academy_id = this.localUser.academy_id
      }

      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    hideAddWindow() {
      this.classShowAddWindow = {}
    },
    // 审核
    showExamineWindow(id) {
      this.querySingle(id, 2)
      this.classShowExamineWindow = {
        visibility: 'visible'
      }
    },
    hideExamineWindow(id) {
      this.formInfo.audit_option = null
      this.classShowExamineWindow = {}
    },
    // 打开负责人弹窗
    showPersonWindow(item) {
      this.userForm.title = item.title
      this.userForm.experiment_id = item.id
      this.userForm.manager_id = item.manager_id
      if ([0].indexOf(this.localUser.role) < 0) {
        this.userInfo.province = this.localUser.province
        this.getSchool(this.localUser.province, 1)
      }
      this.classShowPersonWindow = {
        display: 'block'
      }
      this.getUser()
    },
    // 关闭负责人弹窗
    hidePersonWindow() {
      this.formInfo.id = 0
      this.userInfo.province = ''
      this.userInfo.school_id = ''
      this.userInfo.academy_id = ''
      this.userInfo.username = ''
      this.userInfo.name = ''
      this.searceSchoolData = []
      this.classShowPersonWindow = {
        display: 'none'
      }
    },
    // 查询负责人
    async getUser() {
      await this.$http.get('/userprofile/', {
        params: this.userInfo
      }).then((data) => {
        this.userData = data.results
        this.userDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取人员列表失败！')
      })
    },
    stateSearch(index) {
      this.queryInfo.status = index
      this.search()
    },
    // 搜索
    async search() {
      const params = JSON.parse(JSON.stringify(this.queryInfo))
      if (parseInt(this.localUser.role) > 4) {
        params.manager_id = this.localUser.profile_id
      }
      await this.$http.get('/lesson_list/', {
        params: params
      }).then((data) => {
        if (data.code === '200') {
          this.tableData = data.data.results
          this.tableDataCount = data.data.count
        } else {
          this.$layer.msg('获取课程列表失败！')
        }
      }).catch(() => {
        this.$layer.msg('获取课程列表失败！')
      })
    },
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$layer.msg('请输入课程名称！')
        return
      }
      if (!this.formInfo.province) {
        this.$layer.msg('请选择省份！')
        return
      }
      if (!this.formInfo.school_id) {
        this.$layer.msg('请选择学校！')
        return
      }
      if (!this.formInfo.academy_id) {
        this.$layer.msg('请选择学院！')
        return
      }
      if (!this.formInfo.subjectCategory_id) {
        this.$layer.msg('请选择专业大类！')
        return
      }
      if (!this.formInfo.subject_id) {
        this.$layer.msg('请选择专业！')
        return
      }
      if (this.formInfo.id) {
        const url = '/lesson_online/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.search()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        const titleData = await this.$http.get('/lesson_online/', {
          params: {
            eq_title: this.formInfo.title
          }
        })
        if (titleData.results.length > 0) {
          this.$layer.msg('课程名称已存在！')
          return
        }
        this.formInfo.createUser_id = this.localUser.profile_id
        if (this.localUser.role === 11) {
          this.formInfo.manager_id = this.localUser.profile_id
        }
        this.formInfo.term = 1
        await this.$http.post('/lesson_online/', this.formInfo).then(async (data) => {
          if (data.id) {
            // 添加默认班级
            await this.$http.post('/online_class/', {
              lessonOnline_id: data.id,
              title: '默认班级',
              is_default: 1

            }).then((data) => {
              if (data.id) {
                this.$parent.showMsg('添加成功！')
                this.hideAddWindow()
                this.search()
              }
            })
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 提交审核
    async examineBtn() {
      this.formInfo.audit_option = this.formInfo.audit_option ? this.formInfo.audit_option : null
      this.formInfo.auditor_id = this.localUser.profile_id
      const url = '/lesson_online/' + this.formInfo.id + '/'
      await this.$http.put(url, {
        title: this.formInfo.title,
        audit_option: this.formInfo.audit_option ? this.formInfo.audit_option : null,
        auditor_id: this.localUser.profile_id,
        status: this.formInfo.status
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('审核成功！')
          this.search()
          this.hideExamineWindow()
        } else {
          this.$layer.msg('审核失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('审核失败！')
      })
    },
    // 编辑时查询
    async querySingle(id, type) {
      const url = '/lesson_online/' + id + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo.id = data.id
        this.formInfo.title = data.title
        this.formInfo.province = data.province
        await this.getSchool(this.formInfo.province)
        this.formInfo.school_id = data.school_id
        await this.getAcademy(this.formInfo.school_id)
        this.formInfo.academy_id = data.academy_id
        this.formInfo.subjectCategory_id = data.subjectCategory_id
        await this.getSubject(this.formInfo.subjectCategory_id)
        this.formInfo.subject_id = data.subject_id
        this.formInfo.status = type === 1 ? data.status : 2
        if (type === 1) {
          this.classShowAddWindow = {
            visibility: 'visible'
          }
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },

    // 设为可编辑
    async Editable(item) {
      const url = '/lesson_online/' + item.id + '/'
      await this.$parent.showConfirm('是否确认设为可编辑状态？', () => {
        this.$http.put(url, {
          status: 0,
          title: item.title
        }).then((data) => {
          this.$parent.showMsg('设置成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('设置失败！')
        })
      })
    },
    // 发布
    async askRelease(item) {
      var mytime = this.getCurrentTime()
      const url = '/lesson_pub/'
      var tips = ''
      var status = ''
      if (item.status === 2) {
        tips = '确认发布吗？'
        status = 5
      } else if (item.status === 5) {
        tips = '确认取消发布吗？'
        status = 2
      }
      await this.$parent.showConfirm(tips, () => {
        this.$http.post(url, {
          id: item.id,
          status: status,
          pubDate: status === 5 ? mytime : ''
        }).then((data) => {
          this.$parent.showMsg('操作成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('操作失败！')
        })
      })
    },
    // 删除
    async askDel(item) {
      const url = '/lesson_online/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1,
          title: item.title
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    // 添加负责人
    async selectManager(id) {
      const url = '/lesson_online/' + this.userForm.experiment_id + '/'
      await this.$http.put(url, {
        manager_id: id,
        title: this.userForm.title,
        managerTask: '负责人'
      }).then((data) => {
        if (data.id) {
          this.hidePersonWindow()
          this.search()
        } else {
          this.$parent.$parent.showMsg('选择失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('选择失败！')
      })
    },
    // 获取当前时间
    getCurrentTime() {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      const hh = new Date().getHours()
      const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      _this.gettime = yy + '-' + mm + '-' + dd + 'T' + hh + ':' + mf + ':' + ss
      return _this.gettime
    },
    async addTerm (item) {
      await this.$http.post('/lesson_new_term/', {
        id: item.id
      }).then((data) => {
        if (data.code === '200') {
          this.$parent.showMsg(data.msg)
          this.search()
        } else {
          this.$parent.showMsg(data.msg)
        }
      })
    },
    async getSchool(value, category) {
      const params = {
        page: 1,
        size: 10000,
        province: value,
        status: 1
      }
      if (value) {
        await this.$http.get('/school/', { params }).then((data) => {
          if (category) {
            this.searceSchoolData = data.results
            this.searchAcademyData = []
            this.querymajorData = []
            this.queryInfo.school_id = ''
            this.queryInfo.academy_id = ''
          } else {
            this.schoolData = data.results
            this.majorData = []
            this.academyData = []
            this.formInfo.school_id = ''
            this.formInfo.academy_id = ''
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.searceSchoolData = []
        this.searchAcademyData = []
        this.querymajorData = []
        this.majorData = []
        this.academyData = []
        this.schoolData = []
        this.queryInfo.school_id = ''
        this.queryInfo.academy_id = ''
        this.queryInfo.major_id = ''
        this.formInfo.school_id = ''
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      }
    },
    // 获取所有院系
    async getAcademy(value, category) {
      const params = {
        page: 1,
        size: 10000,
        school_id: value,
        status: 1
      }
      if (value) {
        await this.$http.get('/academy/', { params }).then((data) => {
          if (category) {
            this.searchAcademyData = data.results
          } else {
            this.academyData = data.results
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.searchAcademyData = []
        this.academyData = []
        this.querymajorData = []
        this.majorData = []
        this.queryInfo.academy_id = ''
        this.queryInfo.major_id = ''
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      }
    },
    // 搜索大类
    async searchCategory() {
      await this.$http.get('/subject_category/', {
        params: {
          page: 1,
          size: 100000
        }
      }).then((data) => {
        this.categoryData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 搜索专业
    async getSubject(id, val) {
      this.subjectData = []
      this.queryInfo.subject_id = ''
      const params = {
        page: 1,
        size: 100000,
        subject_category_id: id
      }
      if (id) {
        await this.$http.get('/subject/', {
          params: params
        }).then((data) => {
          if (val) {
            this.subjectData = data.results
          } else {
            this.formSubjectData = data.results
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    }

  },
  // 生命周期-实例创建完成后调用
  created () {
  },
  // 生命周期-实例挂载后调用
  mounted () {
    if ([4].indexOf(this.localUser.role) >= 0) {
      this.queryInfo.academy_id = this.localUser.academy_id
    }
    if ([3].indexOf(this.localUser.role) >= 0) {
      this.queryInfo.school_id = this.localUser.school_id
      this.getAcademy(this.localUser.school_id, 1)
    }
    if ([2].indexOf(this.localUser.role) >= 0) {
      this.queryInfo.province = this.localUser.province
      this.getSchool(this.localUser.province, 1)
    }

    this.search()
    this.searchCategory()
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    useInfo() {
      return {
        page: this.userInfo.page,
        all: Math.ceil(this.userDataCount / this.userInfo.size),
        totalData: this.userDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    },
    dict_province() {
      return this.$store.state.dict_province
    }
  }
}
</script>
<style scoped src="@/assets/css/project-detail.css"></style>
<style lang="less" scoped>
.state-btn {
  display: inline-block;
  overflow: hidden;
  background: #999999;
  .li {
    cursor: pointer;
    float: left;
    width: 90px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #ffffff;
  }
  .liActive {
    background: #73D6CA;
  }
}
</style>
